import React, { useEffect } from "react";
import { Alert } from "@sumprio/ui";
import { useAppSelector, useAppDispatch } from "../types/hooks";
import { clearGlobalAlert, selectGlobalAlert } from "../store/globalAlertSlice";
import { formatAlertMessage } from "utils/formatAlertMessage";
import { AUTO_DISMISS_ALERT_MS, Z_INDEX_APP_NOTIFICATIONS_LAYER } from "constants/alert.constants";

const ALERT_FALLBACK = "Something went wrong. Please try again.";

export default function GlobalAlerts() {
  const dispatch = useAppDispatch();
  const { message, status, dismissible, instanceId } = useAppSelector(selectGlobalAlert);

  const hasActiveAlert = typeof message === "string" && message.trim() !== "";
  const text = hasActiveAlert ? formatAlertMessage(message, ALERT_FALLBACK) : "";

  useEffect(() => {
    if (!hasActiveAlert || !text.trim()) return;
    const id = setTimeout(() => dispatch(clearGlobalAlert()), AUTO_DISMISS_ALERT_MS);
    return () => clearTimeout(id);
  }, [hasActiveAlert, text, dispatch, instanceId]);

  if (!hasActiveAlert || !text.trim()) return null;

  return (
    <div
      className="global-alerts-root"
      style={{
        position: "fixed",
        inset: 0,
        pointerEvents: "none",
        zIndex: Z_INDEX_APP_NOTIFICATIONS_LAYER,
      }}
    >
      <Alert
        position="top-right"
        status={status}
        title={text}
        showTitle
        showDescription={false}
        showCloseIcon={dismissible}
        onDismiss={dismissible ? () => dispatch(clearGlobalAlert()) : undefined}
      />
    </div>
  );
}
